import React from "react";
import { GlassCard } from "@/components/common/GlassCard";

export function EmptyState({ icon: Icon, title, description, action }) {
  return (
    <GlassCard className="flex flex-col items-center justify-center px-6 py-16 text-center">
      {Icon && (
        <div className="mb-5 flex h-16 w-16 items-center justify-center rounded-2xl border border-border bg-secondary/40">
          <Icon className="h-7 w-7 text-gold" />
        </div>
      )}
      <h3 className="font-heading text-xl font-semibold tracking-tight">{title}</h3>
      {description && (
        <p className="mt-2 max-w-sm text-sm text-muted-foreground">{description}</p>
      )}
      {action && <div className="mt-6">{action}</div>}
    </GlassCard>
  );
}
